import React from 'react';

import { TransactionHistoryWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const TransactionHistoryRoute: React.FC = () => (
  <FirstRoute component={TransactionHistoryWizard} noCache />
);

export default TransactionHistoryRoute;
